import { roundQuantity, sumQuantities, validMarbleQuantity } from "./marbleQuantity";
export const PRODUCT_TYPES = { slab: "Slabs", tile: "Tiles", cut_to_size: "Cut-to-size pieces" };
export const stockCountLabel = type => type === "tile" || type === "cut_to_size" ? "Piece count" : "Slab count";
export const stockCountUnit = type => type === "tile" || type === "cut_to_size" ? "pieces" : "slabs";

export function saleStockForecast(distributionId, rows, distributions, reservations, excludeReservationId = null) {
  const distribution = distributions.find(row => String(row.id) === String(distributionId));
  if (!distribution) return null;
  const selling = sumQuantities(rows.filter(row => String(row.distribution_id) === String(distributionId))
    .map(row => Number.isFinite(Number(row.slabs_sold)) && Number(row.slabs_sold) > 0 ? row.slabs_sold : 0));
  const current = Number(distribution.slabs_count || 0);
  const reserved = reservedQuantity(reservations, distribution.id, excludeReservationId);
  return {current, selling, after:roundQuantity(current - selling), reserved};
}

export function businessDate(date = new Date()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "Africa/Cairo", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(date);
  const part = (type) => parts.find((item) => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
}

export function reservationStatus(reservation, today = businessDate()) {
  if (reservation.status && reservation.status !== "active") return reservation.status;
  return reservation.expire_date && reservation.expire_date.slice(0, 10) < today ? "expired" : "active";
}

export function reservedQuantity(reservations, distributionId, excludeId = null, today = businessDate()) {
  return sumQuantities(reservations.map(reservation => {
    if (String(reservation.distribution_id) !== String(distributionId) ||
        (excludeId != null && String(reservation.id) === String(excludeId)) ||
        reservationStatus(reservation, today) !== "active") return 0;
    return Math.max(0, Number(reservation.slabs_reserved) || 0);
  }));
}

export function availableQuantity(distribution, reservations, excludeId = null, today = businessDate()) {
  if (!distribution) return 0;
  return Math.max(0, roundQuantity(Number(distribution.slabs_count || 0) -
    reservedQuantity(reservations, distribution.id, excludeId, today)));
}

export function validateSaleStock(items, distributions, reservations, excludeId = null) {
  const totals = new Map();
  for (const item of items) {
    if (!item.distribution_id || !validMarbleQuantity(item.slabs_sold)) {
      return "Enter a positive quantity and select product stock.";
    }
    const id = String(item.distribution_id);
    totals.set(id, sumQuantities([totals.get(id) || 0,item.slabs_sold]));
  }
  for (const [id, quantity] of totals) {
    const distribution = distributions.find((row) => String(row.id) === id);
    if (!distribution || quantity > availableQuantity(distribution, reservations, excludeId)) {
      return "Requested quantity exceeds stock available after reservations. Refresh stock and review the line items.";
    }
  }
  return "";
}
